import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '@/features/marketing/components/marketing-page'
import { frContent } from '@/features/marketing/content'

export const Route = createFileRoute('/fr/cas-d-usage')({
  component: FrUseCasesPage,
})

function FrUseCasesPage() {
  return <MarketingPage {...frContent.useCases} />
}
